import React, { useEffect, useState } from 'react';

/**
 * Sélecteur de rubrique ICPE pour qualifier un PCE TICGN.
 * Liste publique chargée depuis /api/icpe-rubriques.
 *
 * Props:
 *  - value : numéro ICPE actuellement sélectionné (string ou null)
 *  - onChange(numero, rubriqueObj) : callback déclenché à la sélection
 *  - testId : suffixe data-testid
 */
const IcpeRubriqueSelector = ({ value, onChange, testId = '' }) => {
  const [rubriques, setRubriques] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/icpe-rubriques`)
      .then(r => r.ok ? r.json() : [])
      .then(data => setRubriques(data || []))
      .catch(() => setRubriques([]))
      .finally(() => setLoading(false));
  }, []);

  const selected = rubriques.find(r => r.numero === value);

  return (
    <div>
      <label className="block text-xs font-medium text-[#687175] mb-1">
        Rubrique ICPE <span className="text-[#687175] italic">(optionnel)</span>
      </label>
      <select
        value={value || ''}
        onChange={e => {
          const numero = e.target.value || null;
          const obj = numero ? rubriques.find(r => r.numero === numero) : null;
          onChange?.(numero, obj || null);
        }}
        disabled={loading}
        className="w-full px-3 py-2 border border-[#BFC6CC] rounded-lg text-sm disabled:opacity-50"
        data-testid={`icpe-select${testId ? '-' + testId : ''}`}
      >
        <option value="">— Aucune rubrique ICPE —</option>
        {rubriques.map(r => (
          <option key={r.id || r.numero} value={r.numero}>
            {r.numero} — {r.libelle.length > 80 ? r.libelle.slice(0, 80) + '…' : r.libelle}
          </option>
        ))}
      </select>
      {selected?.eligible_exoneration && (
        <div className="mt-1 text-xs text-emerald-700 flex items-center gap-1" data-testid={`icpe-eligible${testId ? '-' + testId : ''}`}>
          <span className="inline-block w-1.5 h-1.5 bg-emerald-500 rounded-full" />
          Cette rubrique qualifie le site pour l'exonération TICGN
        </div>
      )}
    </div>
  );
};

export default IcpeRubriqueSelector;
